'use strict';

import 'angular';

import service from './service';

const MODULE_NAME = 'daupler.incidents.services.incidents';

var app = angular.module(MODULE_NAME, [
	'brg.pubsub.pusher',
]);
app.service('incidents', service);

export default MODULE_NAME;
